import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "@/components/ThemeProvider";

// Handle Vite module preload errors by reloading the page
window.addEventListener('vite:preloadError', (event) => {
  console.warn('Preload error detected, reloading page...', event);
  window.location.reload();
});

// Service worker registration removed - not configured

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="light" storageKey="classplan-ui-theme">
    <App />
  </ThemeProvider>
);
